<template>
  <login-layout :title="pwdTit">
    <div class="login-suc-box">
      <i class=" icon iconfont iconicon-test33 suc-ico" />
      <p>{{ $t('message["1569"]') }}</p>
      <p>{{ duration }}{{ $t('message["642"]') }}…</p>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/account/LoginLayout'
export default {
  name: 'FindPwdS',
  components: {
    LoginLayout
  },
  data () {
    return {
      duration: 5
    }
  },
  computed: {
    pwdTit () {
      return this.$t('message["1573"]')
    }
  },
  created () {
    const interval = setInterval(() => {
      if (this.duration > 1) {
        this.duration--
      } else {
        this.$router.push('/account/login')
        clearInterval(interval)
      }
    }, 1000)
  }
}
</script>
<style lang="scss" scoped>
  .login-suc-box {
    text-align: center;
    padding-top:0;
    padding-bottom: 120px;

    i {
      margin: 0 auto 16px;
      display: block;
      font-size: 56px;
      color: #42c27e;
    }

    p {
      line-height: 24px;
      font-weight: bold;
    }
  }
</style>
